/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconStack16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStack16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M11.378 1.536c.545.226.997.625 1.289 1.13H3.333a2.667 2.667 0 0 1 1.29-1.13c.49-.203.801-.203 2.044-.203h2.646c.953 0 1.575 0 2.065.203Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 6.666c1.242 0 1.864 0 2.354.203.653.271 1.172.79 1.443 1.444.203.49.203 1.11.203 2.353s0 1.864-.203 2.354a2.666 2.666 0 0 1-1.443 1.443c-.49.203-1.111.203-2.354.203H6c-1.243 0-1.864 0-2.354-.203a2.666 2.666 0 0 1-1.443-1.443C2 12.53 2 11.91 2 10.666c0-1.242 0-1.863.203-2.353.27-.654.79-1.173 1.443-1.444.49-.203 1.111-.203 2.354-.203h4Zm0 6.667H6c-.64 0-1.052 0-1.368-.022-.304-.021-.42-.056-.476-.08a1.333 1.333 0 0 1-.721-.721c-.023-.056-.059-.171-.08-.475a22.56 22.56 0 0 1-.022-1.369c0-.64.001-1.052.023-1.368.02-.304.056-.42.079-.475.135-.327.395-.587.721-.722.056-.023.172-.058.476-.079C4.948 8 5.36 8 6 8h4c.64 0 1.052 0 1.368.022.304.02.42.056.476.08.326.134.586.394.721.72.023.056.059.172.08.476.02.316.022.729.022 1.368 0 .64-.001 1.053-.023 1.369-.02.304-.056.42-.079.475a1.334 1.334 0 0 1-.721.722c-.056.023-.172.058-.476.079a22.51 22.51 0 0 1-1.368.022Z"
                fill="currentColor"
            />
            <path
                d="M12.044 4.203c.546.225.997.624 1.29 1.13H2.666a2.667 2.667 0 0 1 1.289-1.13C4.446 4 5.066 4 6.309 4h3.382c1.242 0 1.863 0 2.353.203Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconStack20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStack20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M14.222 1.92a3.333 3.333 0 0 1 1.611 1.414H4.167c.365-.632.93-1.131 1.61-1.413.613-.254 1.003-.254 2.556-.254h3.308c1.192 0 1.969 0 2.581.254Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 8.334c1.553 0 2.33 0 2.942.253a3.333 3.333 0 0 1 1.804 1.804c.254.613.254 1.39.254 2.943 0 1.553 0 2.33-.254 2.942a3.333 3.333 0 0 1-1.804 1.804c-.612.254-1.389.254-2.942.254h-5c-1.553 0-2.33 0-2.942-.254a3.333 3.333 0 0 1-1.804-1.804c-.254-.613-.254-1.39-.254-2.942 0-1.553 0-2.33.254-2.943a3.333 3.333 0 0 1 1.804-1.804c.612-.253 1.389-.253 2.942-.253h5Zm0 8.333h-5c-.8 0-1.315 0-1.71-.028-.38-.026-.525-.07-.594-.099a1.666 1.666 0 0 1-.902-.902c-.03-.07-.074-.214-.1-.594-.026-.395-.027-.911-.027-1.71 0-.8 0-1.316.028-1.71.025-.38.07-.526.099-.595.169-.408.493-.733.902-.902.069-.029.214-.073.594-.099.395-.027.91-.028 1.71-.028h5c.8 0 1.315.001 1.71.028.38.026.525.07.595.1.408.168.732.493.902.901.028.07.073.214.098.594.027.395.028.911.028 1.71 0 .8 0 1.316-.027 1.711-.026.38-.07.525-.1.594-.169.409-.493.733-.901.902-.07.029-.215.073-.595.1-.395.026-.91.027-1.71.027Z"
                fill="currentColor"
            />
            <path
                d="M15.056 5.254a3.334 3.334 0 0 1 1.61 1.413H3.334c.365-.632.93-1.13 1.611-1.413C5.557 5 6.334 5 7.887 5h4.226c1.553 0 2.33 0 2.943.254Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconStack24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStack24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M17.067 2.304A4 4 0 0 1 19 4H5a4 4 0 0 1 1.933-1.696C7.668 2 8.136 2 10 2h3.97c1.43 0 2.361 0 3.097.304Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 10c1.864 0 2.796 0 3.53.305a4 4 0 0 1 2.165 2.164C21 13.204 21 14.136 21 16s0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C17.796 22 16.864 22 15 22H9c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C3 18.796 3 17.864 3 16s0-2.796.304-3.53a4 4 0 0 1 2.165-2.165C6.204 10 7.136 10 9 10h6Zm0 10H9c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C5.001 17.578 5 16.96 5 16c0-.96.001-1.579.033-2.053.032-.455.085-.63.12-.712a2 2 0 0 1 1.082-1.083c.083-.034.257-.087.713-.119C7.42 12.001 8.04 12 9 12h6c.96 0 1.578.001 2.052.033.457.032.63.085.713.12a2 2 0 0 1 1.083 1.082c.034.083.088.257.119.713.032.473.033 1.093.033 2.052 0 .96-.001 1.578-.033 2.052-.031.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.256.088-.713.119-.474.032-1.093.033-2.052.033Z"
                fill="currentColor"
            />
            <path
                d="M18.067 6.304A4 4 0 0 1 20 8H4a4 4 0 0 1 1.933-1.696C6.668 6 7.6 6 9.464 6h5.072c1.864 0 2.795 0 3.53.304Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconStack = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStack(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconStack16 {...iconProps} />;
        case '20':
            return <IconStack20 {...iconProps} />;
        case '24':
            return <IconStack24 {...iconProps} />;
        default:
            return <IconStack24 {...iconProps} />;
    }
});
